import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  createAffirasOfSurgeryAction,
  updateAffirasOfSurgeryAction,
} from "../../Actions/AffiarsSurgeryAction/AffiarsOfSurgeryAction";

import { MdOutlineSaveAlt } from "react-icons/md";
import { useReactToPrint } from "react-to-print";
import PrintableContent from "./PrintableContent";
import { FaPrint } from "react-icons/fa6";

const ProfileFollowUp = ({
  affirasOfSurgery,
  activeTab,
  setActiveTab,
  visit,
  forms,
}) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({});
  const [dateManualy, setDateManualy] = useState(null);
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setDateManualy(formattedDate);
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  // console.log(visit);
  const handleSubmit = (event) => {
    event.preventDefault();
    let types = [];
    let notes = [];
    let ids = [];
    
    Object.entries(state).map(([key, value]) => {
      types.push(key);
      notes.push(value);
    });
    setActiveTab(activeTab);

    if (affirasOfSurgery.length > 0) {
      affirasOfSurgery.map((affiars) => {
        ids.push(affiars.id);
      });
      

      dispatch(
        updateAffirasOfSurgeryAction(
          ids,
          types,
          notes,
          visit.id,
          visit.patient_id
        )
      );
    } else {
      dispatch(
        createAffirasOfSurgeryAction(types, notes, visit.id, visit.patient_id)
      );
    }
  };
  useEffect(() => {
    const tempState = {};

    if (affirasOfSurgery.length > 0) {
      affirasOfSurgery.map((affiar) => {
        tempState[affiar.type] = affiar.note;
      });
      setState({ ...tempState });
    } else {
      forms?.map((form) => {
        form?.sectionForm.map((section) => {
          section?.field?.map((field) => {
            tempState[field.name] = null;
          });
        });
      });
    }
    setState({ ...tempState });
  }, [forms, affirasOfSurgery]);
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <div>


      {/* <div className="" ref={}>
        sdfksdjfksdf
      </div> */}
      <form action="">
        {forms?.map((form, formIndex) => {
          return form.sectionForm.map((section, sectionIndex) => {
            return (
              <div key={formIndex + sectionIndex} ref={componentRef}>
                <div
                  className="bg-teal-500 p-1.5 lg:w-3/12 my-2 m-auto rounded-sm text-white text-center shadow-md"
                  key={sectionIndex}
                >
                  {section.title}
                </div>
                <div className="flex flex-row-reverse justify-center items-center flex-wrap gap-3 my-2">
                  {section.field.map((field, index) => {
                    return (
                      <>
                        {(field.type == "text" ||
                          field.type == "number" ||
                          field.type == "dropdown") && (
                          <div className="flex flex-col text-right basis-1/5">
                            <div className="w-full mr-2">
                              <label htmlFor="mr-2">* {field.label} </label>
                            </div>
                            {field.type == "textarea" ? (
                              <textarea
                                key={index}
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                onChange={handleInputChange}
                                value={state[field.name]}
                                className="p-1.5 input text-right"
                              ></textarea>
                            ) : field.type == "dropdown" ? (
                              <select
                                key={index}
                                className="p-1.5 w-full input text-right"
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                onChange={handleInputChange}
                                value={state[field.name]}
                                id=""
                              >
                                <option value="">
                                  تکایە زانیاریەکە هەڵبژێرە
                                </option>
                                {field?.drop_down.map((dropdown, index) => {
                                  return (
                                    <option value={dropdown.value} key={index}>
                                      {dropdown.value}
                                    </option>
                                  );
                                })}
                              </select>
                            ) : (
                              <input
                                key={index}
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                onChange={handleInputChange}
                                value={state[field.name]}
                                className="p-1.5 input w-full text-right"
                              />
                            )}
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>

                <hr />

                {section.field.map((field, index) => {
                  return (
                    <React.Fragment>
                      {field.type == "textarea" ? (
                        <textarea
                          key={index}
                          type={field.type}
                          name={field.name}
                          placeholder={field.placeholder}
                          onChange={handleInputChange}
                          value={state[field.name]}
                          className="p-1.5 input text-right w-full mt-2"
                        ></textarea>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            );
          });
        })}

        <input
          type="date"
          className="dateManualy w-full input hidden"
          readOnly
          disabled
          // onChange={(e) => setState({ ...state, dateManualy: e.target.value })}
          value={dateManualy}
          name=""
          id=""
        />
        <div className="flex gap-5">
        <button onClick={handleSubmit} className="btn-blue mt-2">
          Save <MdOutlineSaveAlt />
        </button>
     
        </div>
     
      </form>
      <button className="btn-teal mt-2" onClick={handlePrint}>Print <FaPrint/></button>
      <div hidden>
      <PrintableContent ref={componentRef} forms={forms} state={state} />
      </div>
      
        <div className="pb-20"></div>
    </div>
  );
};

export default ProfileFollowUp;
